"use client";

import { ReactNode } from "react";
import { TriangleAlert } from "lucide-react";
import { Card, CardContent, Stack, Text } from "@leabankab/component-library";
import { useAppCountry } from "@/hooks/use-app-country";

type Props = {
	title: string;
	children: ReactNode;
};

export const LoanDisclaimer = ({ title, children }: Props) => {
	const country = useAppCountry();
	if (country !== "SE") return null;
	return (
		<Card>
			<CardContent className="flex gap-1">
				<TriangleAlert
					size={52}
					aria-hidden
					className="text-status-error-base w-fit shrink-0"
					strokeWidth={1.5}
				/>
				<Stack gap={0}>
					<Text
						render={<p />}
						textStyle="body-sm"
						fontWeight="medium"
						color="text.base"
					>
						{title}
					</Text>
					<Text
						render={<p />}
						textStyle="body-sm"
						color="text.subtle"
					>
						{children}
					</Text>
				</Stack>
			</CardContent>
		</Card>
	);
};
